import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-primary-deep-blue text-white" data-id="element-163">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-164">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-165">
          {/* Organization Info */}
          <div data-id="element-166">
            <h3 className="text-xl font-playfair mb-4" data-id="element-167">Farasha Medical Aid</h3>
            <p className="font-inter text-sm mb-4" data-id="element-168">
              Connecting American generosity with Egyptian monastery
              communities, delivering essential medical supplies to clinics
              serving populations often overlooked by conventional healthcare
              systems.
            </p>
            <p className="font-inter text-sm" data-id="element-169">
              501(c)(3) nonprofit organization
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-170">
            <h3 className="text-xl font-playfair mb-4" data-id="element-171">Quick Links</h3>
            <ul className="space-y-2 font-inter text-sm" data-id="element-172">
              <li data-id="element-173">
                <Link to="/" className="hover:underline" data-id="element-174">
                  Home
                </Link>
              </li>
              <li data-id="element-175">
                <Link to="/about" className="hover:underline" data-id="element-176">
                  About Us
                </Link>
              </li>
              <li data-id="element-177">
                <Link to="/coptic-people" className="hover:underline" data-id="element-178">
                  The Coptic People
                </Link>
              </li>
              <li data-id="element-179">
                <Link to="/blog" className="hover:underline" data-id="element-180">
                  Blog
                </Link>
              </li>
              <li data-id="element-181">
                <Link to="/contact" className="hover:underline" data-id="element-182">
                  Contact
                </Link>
              </li>
              <li data-id="element-183">
                <Link to="/donate" className="hover:underline" data-id="element-184">
                  Donate
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-185">
            <h3 className="text-xl font-playfair mb-4" data-id="element-186">Legal & Transparency</h3>
            <ul className="space-y-2 font-inter text-sm" data-id="element-187">
              <li data-id="element-188">
                <Link to="/privacy" className="hover:underline" data-id="element-189">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-190">
                <Link to="/terms" className="hover:underline" data-id="element-191">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact & Newsletter */}
          <div data-id="element-192">
            <h3 className="text-xl font-playfair mb-4" data-id="element-193">Stay Connected</h3>
            <div className="space-y-1 mb-4" data-id="element-194">
              <p className="font-inter text-sm" data-id="element-195">
                <a href="mailto:natasha.farashamed@gmail.com" className="hover:underline" data-id="element-196">
                  natasha.farashamed@gmail.com
                </a>
              </p>
              <p className="font-inter text-sm" data-id="element-197">
                <a href="mailto:nicole.farashamed@gmail.com" className="hover:underline" data-id="element-198">
                  nicole.farashamed@gmail.com
                </a>
              </p>
            </div>
            <div className="flex space-x-4 mb-6" data-id="element-199">
              <a href="https://www.facebook.com/people/Farasha-Medical-Aid/61577192704150/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-primary-gold transition-colors" data-id="element-200">
                <Facebook size={20} data-id="element-201" />
              </a>
              <a href="https://www.instagram.com/farasha.medical/?utm_source=ig_web_button_share_sheet" target="_blank" rel="noopener noreferrer" className="text-white hover:text-primary-gold transition-colors" data-id="element-202">
                <Instagram size={20} data-id="element-203" />
              </a>
              <a href="https://www.linkedin.com/in/natasha-khalil-905309256/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-primary-gold transition-colors" data-id="element-204">
                <Linkedin size={20} data-id="element-205" />
              </a>
              <a href="mailto:natasha.farashamed@gmail.com" className="text-white hover:text-primary-gold transition-colors" data-id="element-206">
                <Mail size={20} data-id="element-207" />
              </a>
            </div>
            <h4 className="font-inter font-medium mb-2" data-id="element-208">
              Subscribe to our newsletter
            </h4>
            <form className="flex" data-id="element-209">
              <input type="email" placeholder="Your email" className="px-3 py-2 bg-white text-primary-deep-blue rounded-l-md w-full focus:outline-none" data-id="element-210" />
              <button type="submit" className="bg-primary-gold hover:bg-primary-royal-blue text-white px-4 py-2 rounded-r-md transition-colors" data-id="element-211">
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8 text-sm font-inter text-center" data-id="element-212">
          <p data-id="element-213">
            © {new Date().getFullYear()} Farasha Medical Aid. All rights
            reserved.
          </p>
          <p className="mt-2" data-id="element-214">
            Donations are tax-deductible to the extent allowed by law.
          </p>
        </div>
      </div>
    </footer>;
}